{
  "pages": [
    {
      "name": "Mixit",
      "elements": [
        {
          "type": "panel",
          "name": "firstpanel",
          "title": "Mixit",
          "elements": [
            {
              "type": "text",
              "name": "title",
              "title": "System name"
            },
            {
              "type": "dropdown",
              "name": "ValveVariant",
              "title": "Orientation",
              "isRequired": true,
              "visibleIf": "{IsOnboarded} != true",
              "choices": [
                {
                  "value": "MIXING_LOOP_VALVE_LEFT_RIGHT_VARIANT_LEFT_VALVE",
                  "text": "Left"
                },
                {
                  "value": "MIXING_LOOP_VALVE_LEFT_RIGHT_VARIANT_RIGHT_VALVE",
                  "text": "Right"
                }
              ]
            },
            {
              "type": "text",
              "name": "Orientation",
              "title": "Orientation (DEPRECATED)",
              "isRequired": true,
              "visibleIf": "false"
            }
          ]
        },
        {
          "type": "panel",
          "name": "panel3",
          "visibleIf": "false",
          "elements": [
            {
              "type": "boolean",
              "name": "Standalone",
              "title": "Standalone",
              "isRequired": false,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "IsOnboarded",
              "title": "IsOnboarded",
              "isRequired": false,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "Connect",
              "title": "Connect",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "Dynamic",
              "title": "Dynamic",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "DoubleShunt",
              "title": "DoubleShunt",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "text",
              "name": "ProductType",
              "title": "ProductType",
              "isRequired": true
            },
            {
              "type": "dropdown",
              "name": "Application",
              "title": "Application",
              "isRequired": true,
              "choices": [
                {
                  "value": "MIXING_LOOP_APPLICATION_TYPE_RADIATOR_HEATING",
                  "text": "Radiator Heating"
                },
                {
                  "value": "MIXING_LOOP_APPLICATION_TYPE_FLOOR_HEATING",
                  "text": "Underfloor Heating"
                },
                {
                  "value": "MIXING_LOOP_APPLICATION_TYPE_HEATING_COIL",
                  "text": "Heating Coil"
                },
                {
                  "value": "MIXING_LOOP_APPLICATION_TYPE_COOLING_COIL",
                  "text": "Cooling Coil"
                },
                {
                  "value": "MIXING_LOOP_APPLICATION_TYPE_FAN_COIL",
                  "text": "Fan Coil"
                },
                {
                  "value": "MIXING_LOOP_APPLICATION_TYPE_RADIANT_HEATING_PANELS",
                  "text": "Radiant Heating Panels"
                },
                {
                  "value": "NONE",
                  "text": "None"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "ThermalApplicationType",
              "title": "Thermal application",
              "isRequired": false,
              "choices": [
                {
                  "value": "MIXING_LOOP_THERMAL_APPLICATION_TYPE_HEAT_APPL",
                  "text": "MIXIT for heating"
                },
                {
                  "value": "MIXING_LOOP_THERMAL_APPLICATION_TYPE_COOL_APPL",
                  "text": "MIXIT for cooling"
                },
                {
                  "value": "MIXING_LOOP_THERMAL_APPLICATION_TYPE_COMBINED_HEAT_COOL",
                  "text": "MIXIT for heating and cooling"
                },
                {
                  "value": "MIXING_LOOP_THERMAL_APPLICATION_TYPE_NONE",
                  "text": "Unknown"
                }
              ]
            },
            {
              "type": "text",
              "name": "HydraulicConfiguration",
              "title": "HydraulicConfiguration",
              "isRequired": true
            }
          ],
          "title": "Mixit"
        },
        {
          "type": "panel",
          "name": "panel1",
          "visibleIf": "false",
          "elements": [
            {
              "type": "boolean",
              "name": "T_PF_present",
              "title": "Primary Forward temperature",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_PR_present",
              "title": "Primary Return temperature",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_SR_present",
              "title": "Secondary Return temperature",
              "labelTrue": "Yes",
              "labelFalse": "No"
            }
          ],
          "title": "Temperature Sensor Choices"
        },
        {
          "type": "panel",
          "name": "panel7",
          "visibleIf": "false",
          "elements": [
            {
              "type": "dropdown",
              "name": "P_type",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "Magna3",
                  "text": "Magna3"
                },
                {
                  "value": "Magna3D",
                  "text": "Magna3D"
                },
                {
                  "value": "TPE3",
                  "text": "TPE3"
                },
                {
                  "value": "TPE3D",
                  "text": "TPE3D"
                },
                {
                  "value": "UnknownPumpMIXIT",
                  "text": "UnknownPumpMIXIT"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "P_location",
              "title": "Location",
              "isRequired": true,
              "choices": [
                {
                  "value": "SecondaryForward",
                  "text": "Secondary forward"
                },
                {
                  "value": "SecondaryReturn",
                  "text": "Secondary return"
                }
              ]
            }
          ],
          "title": "Pump"
        },
        {
          "type": "panel",
          "name": "pnlControlValve",
          "visibleIf": "false",
          "elements": [
            {
              "type": "dropdown",
              "name": "MV_valveLocation",
              "title": "Location",
              "isRequired": true,
              "choices": [
                {
                  "value": "PrimaryForward",
                  "text": "Flow pipe"
                },
                {
                  "value": "PrimaryReturn",
                  "text": "Return pipe"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "MV_valveType",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "TwoWayValve",
                  "text": "Two way valve"
                },
                {
                  "value": "ThreeWayValve",
                  "text": "Three way valve"
                }
              ]
            }
          ],
          "title": "Control Valve and Actuator"
        },
        {
          "type": "panel",
          "name": "panel9",
          "visibleIf": "false",
          "elements": [
            {
              "type": "boolean",
              "name": "Control_enabled",
              "title": "Control_enabled",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "HM_BusModule_present",
              "title": "HM_BusModule_present",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "HM_isMounted",
              "title": "HM_isMounted",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "HM_present",
              "title": "HM_present",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "MV_isNotMounted",
              "title": "MV_isNotMounted",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "Modulation_control",
              "title": "Modulation_control",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "OnOff_control",
              "title": "OnOff_control",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "P_CIM050_present",
              "title": "P_CIM050_present",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "P_connected",
              "title": "P_connected",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "P_present",
              "title": "P_present",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "PumpTemperatureSensor",
              "title": "PumpTemperatureSensor",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "SP_present",
              "title": "SP_present",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_AIR_isMounted",
              "title": "T_AIR_isMounted",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_PF_isMounted",
              "title": "T_PF_isMounted",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_PR_isMounted",
              "title": "T_PR_isMounted",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_P_F_isMounted",
              "title": "T_P_F_isMounted",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_P_PF_isMounted",
              "title": "T_P_PF_isMounted",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_P_PR_isMounted",
              "title": "T_P_PR_isMounted",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_P_R_isMounted",
              "title": "T_P_R_isMounted",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_SF_present",
              "title": "T_SF_present",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_isMounted",
              "title": "T_isMounted",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "Weather_compensation_enabled",
              "title": "Weather_compensation_enabled",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "text",
              "name": "Model",
              "title": "Model",
              "isRequired": true
            },
            {
              "type": "text",
              "name": "Name",
              "title": "Name",
              "isRequired": true
            },
            {
              "type": "text",
              "name": "ProductId",
              "title": "ProductId",
              "isRequired": true
            },
            {
              "type": "text",
              "name": "ProductNumber",
              "title": "ProductNumber",
              "isRequired": true
            },
            {
              "type": "text",
              "name": "OrientationProductionCode",
              "title": "OrientationProductionCode",
              "isRequired": true
            },
            {
              "type": "text",
              "name": "HM_address",
              "isRequired": true,
              "title": "HM_address",
              "inputType": "number"
            },
            {
              "type": "text",
              "name": "MV_kvs",
              "isRequired": true,
              "title": "MV_kvs",
              "inputType": "number"
            },
            {
              "type": "text",
              "name": "Max_property_value",
              "isRequired": true,
              "title": "Max_property_value",
              "inputType": "number"
            },
            {
              "type": "text",
              "name": "Min_property_value",
              "isRequired": true,
              "title": "Min_property_value",
              "inputType": "number"
            },
            {
              "type": "text",
              "name": "Pipe_dimension",
              "isRequired": true,
              "title": "Pipe_dimension",
              "inputType": "number"
            },
            {
              "type": "text",
              "name": "Q_SC_address",
              "isRequired": true,
              "title": "Q_SC_address",
              "inputType": "number"
            },
            {
              "type": "text",
              "name": "Q_SF_nominal",
              "isRequired": true,
              "title": "Q_SF_nominal",
              "inputType": "number"
            },
            {
              "type": "text",
              "name": "Setpoint",
              "isRequired": true,
              "title": "Setpoint",
              "inputType": "number"
            },
            {
              "type": "text",
              "name": "T_supply",
              "isRequired": true,
              "title": "T_supply",
              "inputType": "number"
            },
            {
              "type": "text",
              "name": "ValveTravelTime",
              "isRequired": true,
              "title": "ValveTravelTime",
              "inputType": "number"
            },
            {
              "type": "boolean",
              "name": "MV_overrideDefaultValveTravelTime",
              "title": "MV_overrideDefaultValveTravelTime",
              "labelTrue": "Yes",
              "labelFalse": "No"
            }
          ]
        }
      ]
    }
  ]
}